import styled from 'styled-components';
import { Box, SideSheetContentCol } from '@bechtel/gds';

export const DocumentHeaderStyled = styled(Box).attrs({
  py: { sm: '400' },
  pl: { sm: '450' },
  flexDirection: { sm: 'column' },
})`
  border-bottom: 1px solid ${({ theme }) => theme.colors.grey[300]};
`;

export const SideSheetContentColStyled = styled(SideSheetContentCol)`
  z-index: 1;
  box-shadow: 0 1px 5px 0 rgba(0, 0, 0, 0.2), 0 3px 1px -2px rgba(0, 0, 0, 0.12), 0 2px 2px 0 rgba(0, 0, 0, 0.14);
  max-width: 240px;
  height: 100vh;
  border-right: 1px solid ${({ theme }) => theme.colors.grey[300]};
`;

export const EmptyDocumentViewStyled = styled(Box).attrs({
  alignItems: { sm: 'center' },
  flexDirection: { sm: 'column' },
})`
  align-items: center;
  justify-content: center;
  height: calc(100vh - 205px);
`;
